var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import * as d3 from 'd3';
import styled from 'styled-components';
import { palette, spacing, borderRadius } from '../../../constants';
import { useCanvas } from '../Canvas';
var Time = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  background-color: ", ";\n  border-radius: ", ";\n  font-size: 10px;\n  padding: ", ";\n"], ["\n  color: ", ";\n  background-color: ", ";\n  border-radius: ", ";\n  font-size: 10px;\n  padding: ", ";\n"])), palette.pureWhite, palette.orange7, borderRadius.default, spacing.extraTight);
var Line = styled.line(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  pointer-events: none;\n  stroke: ", ";\n  stroke-width: 2;\n"], ["\n  pointer-events: none;\n  stroke: ", ";\n  stroke-width: 2;\n"])), palette.orange7);
export var TrackTime = function (_a) {
    var time = _a.time, _b = _a.className, className = _b === void 0 ? 'Chart--TrackLine Chart--TrackTime' : _b;
    var dims = useCanvas();
    var dayTime = time !== undefined ? d3.timeFormat('%a, %H:%M')(time) : null;
    return (React.createElement("g", { className: className },
        React.createElement("g", { transform: "translate(-6, 0)" },
            React.createElement(Line, { x1: 6, x2: 6, y1: dims.margins.top - 5, y2: dims.margins.top + dims.boundedHeight }),
            React.createElement("foreignObject", { width: 100, height: 1, style: { overflow: 'visible' }, transform: "translate(-25, " + (dims.margins.top - 21) + ")" },
                React.createElement(Time, null, dayTime)))));
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=TrackTime.js.map